/* TODO: have this be unit tested */

import React from 'react';
import PropTypes from 'prop-types';
import formatPhone from '~/utils/format/phone';

const TableCellPhone = ({
  value,
}) => (
  <a href={`tel:${value}`}>
    { formatPhone(value) }
  </a>
);

TableCellPhone.propTypes = {
  value: PropTypes.string.isRequired,
};

export default TableCellPhone;
